import { isNotDefined } from '@sgme/fp';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import type { PredealCheck } from '@/types/common.ts';

export type PredealChecksIndicatorProps = {
  predealChecks: PredealCheck[] | undefined;
  globalPreDealCheck: string;
};

const COLOR_BY_PREDEAL_CHECK_STATUS: Record<string, string> = {
  Ok: 'text-success',
  Nok: 'text-danger',
  Warning: 'text-warning',
  Unknown: 'text-muted',
  Missing: 'text-muted',
};

const ICON_BY_PREDEAL_CHECK_STATUS: Record<string, string> = {
  Ok: 'lens',
  Nok: 'lens',
  Warning: 'lens',
  Unknown: 'lens',
  Missing: 'close',
};

/**
 * PredealChecksIndicator displays an icon with predeal checks status for Forward/NDF tiles
 * Shows a popover with detailed checks when clicked
 *
 * @example
 * <PredealChecksIndicator predealChecks={predealChecks} globalPreDealCheck="Ok" />
 */
export function PredealChecksIndicator(props: PredealChecksIndicatorProps) {
  const { predealChecks, globalPreDealCheck } = props;

  if (isNotDefined(predealChecks)) {
    return null;
  }

  return (
    <OverlayTrigger
      trigger="click"
      placement="right"
      rootClose
      overlay={
        <Popover>
          <Popover.Header>
            <FormattedMessage id="cash.forward.predealChecks.title" />
          </Popover.Header>
          <Popover.Body>
            {predealChecks.map((check) => (
              <div key={check.label} className="d-flex justify-content-between border-top py-1">
                <span data-e2e={`predeal-check-${check.label}-label`}>{check.label}</span>
                <i
                  className={`icon ${COLOR_BY_PREDEAL_CHECK_STATUS[check.statusHealth]} fs-14`}
                  data-e2e={`predeal-check-${check.label}`}
                  data-e2e-status={check.statusHealth}
                >
                  {ICON_BY_PREDEAL_CHECK_STATUS[check.statusHealth]}
                </i>
              </div>
            ))}
          </Popover.Body>
        </Popover>
      }
    >
      <i
        className={`icon fs-14 me-2 cursor-pointer ${COLOR_BY_PREDEAL_CHECK_STATUS[globalPreDealCheck]}`}
        data-e2e="predeal-checks"
        data-e2e-status={globalPreDealCheck}
      >
        lens
      </i>
    </OverlayTrigger>
  );
}
